/**
 * GENERATED by `scripts/gen_route_capabilities.mjs` from
 * `contracts/openapi.yaml`. Do not edit by hand: change the contract and run
 * `node scripts/gen_route_capabilities.mjs`. `pnpm lint` fails when this file
 * is stale and `scripts/check_capability_drift.py` (`make contracts`) fails
 * when it disagrees with the contract.
 */
import type { components } from '@cedarreachai/api-client';

type Schemas = components['schemas'];

/**
 * Who, beyond `x-required-capabilities`, may decide a request of one risk
 * class: a holder of any of the roles **or** any of the capabilities.
 */
export interface ApproverDesignation {
  readonly anyOfRoles: readonly Schemas['Role'][];
  readonly anyOfCapabilities: readonly Schemas['Capability'][];
}

/** An operation's `x-required-capabilities` value. */
export type RequiredCapabilities = readonly Schemas['Capability'][];

/**
 * A risk class absent from the rule needs nothing beyond
 * `x-required-capabilities`.
 */
export type ApproverRule = Readonly<Partial<Record<Schemas['RiskClass'], ApproverDesignation>>>;

/**
 * Every mutating operation's `x-required-capabilities`, keyed
 * `"METHOD /path"` with the contract's own path template, in contract order.
 */
export const GENERATED_ROUTE_CAPABILITIES = {
  'POST /api/v1/workspaces': [], // createWorkspace
  'PATCH /api/v1/workspaces/{workspace_id}': ['change_automation_level'], // updateWorkspace
  'PUT /api/v1/workspaces/{workspace_id}/brand-term-stoplist': ['manage_policies'], // setWorkspaceBrandTermStoplist
  'PUT /api/v1/workspaces/{workspace_id}/brand-compounds': ['manage_policies'], // setWorkspaceBrandCompounds
  'POST /api/v1/workspaces/{workspace_id}/members': ['manage_members'], // addWorkspaceMember
  'PATCH /api/v1/workspaces/{workspace_id}/members/{membership_id}': ['manage_members'], // changeWorkspaceMemberRole
  'POST /api/v1/workspaces/{workspace_id}/members/{membership_id}/suspend': ['manage_members'], // suspendWorkspaceMember
  'POST /api/v1/workspaces/{workspace_id}/members/{membership_id}/reinstate': ['manage_members'], // reinstateWorkspaceMember
  'POST /api/v1/workspaces/{workspace_id}/pause': ['global_pause'], // pauseWorkspace
  'POST /api/v1/workspaces/{workspace_id}/resume': ['global_pause'], // resumeWorkspace
  'POST /api/v1/workspaces/{workspace_id}/brands': ['manage_brands'], // createBrand
  'POST /api/v1/workspaces/{workspace_id}/schedules': ['schedule_content'], // createWorkspaceSchedule
  'POST /webhooks/cms/{connector_id}/ack': [], // acknowledgeCmsDelivery
  'POST /auth/logout': [], // signOut
  'POST /e/v1/events': [], // ingestEvent
  'POST /api/v1/workspaces/{workspace_id}/connectors': ['manage_connectors'], // createWebhookConnector
  'POST /api/v1/workspaces/{workspace_id}/connectors/{connector_id}/signing-keys:rotate': [
    'manage_connectors',
  ], // rotateWebhookSigningKey
  'PATCH /api/v1/workspaces/{workspace_id}/connectors/{connector_id}': ['manage_connectors'], // updateWorkspaceConnector
  'DELETE /api/v1/workspaces/{workspace_id}/connectors/{connector_id}': ['manage_connectors'], // revokeWorkspaceConnector
  'PUT /api/v1/workspaces/{workspace_id}/connectors/{connector_id}/metrics-binding': [
    'manage_connectors',
  ], // bindWorkspaceConnectorMetrics
  'POST /api/v1/workspaces/{workspace_id}/connectors/{connector_id}/pause': ['manage_connectors'], // setWorkspaceConnectorPaused
  'POST /api/v1/workspaces/{workspace_id}/connectors/{connector_id}/authorize': [
    'manage_connectors',
  ], // authorizeWorkspaceConnector
  'PATCH /api/v1/workspaces/{workspace_id}/brands/{brand_id}': ['manage_brands'], // updateWorkspaceBrand
  'PUT /api/v1/workspaces/{workspace_id}/brands/{brand_id}/automation-level': [
    'change_automation_level',
  ], // setBrandAutomationLevel
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/facts': ['propose_facts'], // createWorkspaceBrandFact
  'POST /api/v1/workspaces/{workspace_id}/facts/{fact_id}/verify': ['verify_facts'], // verifyWorkspaceFact
  'POST /api/v1/workspaces/{workspace_id}/facts/{fact_id}/revoke': ['verify_facts'], // revokeWorkspaceFact
  'PATCH /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}': ['manage_campaigns'], // updateWorkspaceCampaign
  'POST /api/v1/workspaces/{workspace_id}/content-items/{item_id}/versions': ['edit_content'], // createWorkspaceContentVersion
  'POST /api/v1/workspaces/{workspace_id}/content-items/{item_id}/variants:generate': [
    'run_agents',
  ], // generateWorkspaceContentVariant
  'POST /api/v1/workspaces/{workspace_id}/content-versions/{version_id}/policy:check': [
    'submit_for_approval',
  ], // checkWorkspaceContentPolicy
  'POST /api/v1/workspaces/{workspace_id}/content-versions/{version_id}/approval-requests': [
    'submit_for_approval',
  ], // submitWorkspaceContentForApproval
  'POST /api/v1/workspaces/{workspace_id}/content-versions/{version_id}/export': ['export_data'], // exportWorkspaceContentVersion
  'POST /api/v1/workspaces/{workspace_id}/deliverables/{deliverable_id}/content:generate': [
    'run_agents',
  ], // generateWorkspaceDeliverableContent
  'POST /api/v1/workspaces/{workspace_id}/agent-runs/{run_id}/cancel': ['run_agents'], // cancelWorkspaceAgentRun
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/decide': [
    'approve_content',
  ], // decideWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/schedules/{schedule_id}/cancel': ['schedule_content'], // cancelWorkspaceSchedule
  'DELETE /api/v1/workspaces/{workspace_id}/schedules/{schedule_id}': ['schedule_content'], // deleteWorkspaceSchedule
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/approve': [
    'approve_content',
  ], // approveWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/reject': [
    'approve_content',
  ], // rejectWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/request-changes': [
    'approve_content',
  ], // requestChangesWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/schedules': [
    'schedule_content',
  ], // scheduleWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/publications/{publication_id}/reconcile': [
    'publish_content',
  ], // reconcileWorkspacePublication
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/pause': ['global_pause'], // pauseWorkspaceBrand
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/resume': ['global_pause'], // resumeWorkspaceBrand
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/content:generate': ['run_agents'], // generateWorkspaceCampaignContent
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/properties': ['manage_brands'], // createWorkspaceBrandProperty
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/imports': ['import_sources'], // createWorkspacePropertyImport
  'POST /api/v1/workspaces/{workspace_id}/imports/{import_id}/extract-facts': [
    'run_agents',
    'propose_facts',
  ], // extractWorkspaceImportFacts
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/brand-book/versions': ['manage_brands'], // createWorkspaceBrandBookVersion
  'POST /api/v1/workspaces/{workspace_id}/brand-book-versions/{version_id}/approve': [
    'manage_brands',
  ], // approveWorkspaceBrandBookVersion
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/audience-segments': [
    'manage_campaigns',
  ], // createWorkspaceAudienceSegment
  'POST /api/v1/workspaces/{workspace_id}/brands/{brand_id}/campaigns': ['manage_campaigns'], // createWorkspaceCampaign
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/brief-versions': [
    'manage_campaigns',
  ], // createWorkspaceCampaignBriefVersion
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/approaches:generate': [
    'run_agents',
  ], // generateWorkspaceCampaignApproaches
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/approaches/{index}/choose': [
    'manage_campaigns',
  ], // chooseWorkspaceCampaignApproach
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/plan:generate': ['run_agents'], // generateWorkspaceCampaignPlan
  'PATCH /api/v1/workspaces/{workspace_id}/facts/{fact_id}': ['propose_facts'], // updateWorkspaceFact
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/conversion-goals': [
    'manage_brands',
  ], // createWorkspacePropertyConversionGoal
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/event-key:rotate': [
    'manage_brands',
  ], // rotateWorkspacePropertyEventKey
  'PUT /api/v1/workspaces/{workspace_id}/properties/{property_id}/event-origins': ['manage_brands'], // setWorkspacePropertyEventOrigins
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/tracking-links': [
    'manage_campaigns',
  ], // createWorkspaceCampaignTrackingLink
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/metric-imports': [
    'import_sources',
  ], // createWorkspaceMetricImport
  'POST /api/v1/workspaces/{workspace_id}/campaigns/{campaign_id}/experiments': [
    'manage_experiments',
  ], // createWorkspaceExperiment
  'POST /api/v1/workspaces/{workspace_id}/experiments/{experiment_id}/start': [
    'manage_experiments',
  ], // startWorkspaceExperiment
  'POST /api/v1/workspaces/{workspace_id}/experiments/{experiment_id}/stop': ['manage_experiments'], // stopWorkspaceExperiment
  'POST /api/v1/workspaces/{workspace_id}/experiments/{experiment_id}/results': [
    'manage_experiments',
  ], // recordExperimentResults
  'POST /api/v1/workspaces/{workspace_id}/experiments/{experiment_id}/decisions': [
    'manage_experiments',
  ], // recordExperimentDecision
  'POST /api/v1/workspaces/{workspace_id}/experiments/{experiment_id}/analyze': [
    'manage_experiments',
  ], // analyzeWorkspaceExperiment
  'POST /api/v1/workspaces/{workspace_id}/experiments/{experiment_id}/analyzed': [
    'manage_experiments',
  ], // markWorkspaceExperimentAnalyzed
  'POST /api/v1/workspaces/{workspace_id}/recommendations/{recommendation_id}/accept': [
    'manage_campaigns',
  ], // acceptWorkspaceRecommendation
  'POST /api/v1/workspaces/{workspace_id}/recommendations/{recommendation_id}/dismiss': [
    'manage_campaigns',
  ], // dismissWorkspaceRecommendation
  'POST /api/v1/workspaces/{workspace_id}/recommendations/{recommendation_id}/snooze': [
    'manage_campaigns',
  ], // snoozeWorkspaceRecommendation
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/seo-audits': ['import_sources'], // runSeoAudit
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/seo-opportunities:explain': [
    'run_agents',
  ], // explainSeoOpportunities
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/seo-opportunities/{opportunity_id}/brief':
    ['manage_campaigns'], // createSeoBrief
  'POST /api/v1/workspaces/{workspace_id}/properties/{property_id}/aso-variants:generate': [
    'run_agents',
  ], // generateAsoVariants
} as const satisfies Readonly<Record<string, RequiredCapabilities>>;

/**
 * Every operation carrying `x-approver-rule` (the designated-approver rule
 * by the stored request's risk class): exactly the mutating operations that
 * require `approve_content`. Never empty — the generator refuses a contract
 * without one.
 */
export const GENERATED_APPROVER_RULES: Readonly<
  Partial<Record<keyof typeof GENERATED_ROUTE_CAPABILITIES, ApproverRule>>
> = {
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/decide': {
    high: { anyOfRoles: ['approver'], anyOfCapabilities: ['manage_policies'] },
    critical: { anyOfRoles: ['owner'], anyOfCapabilities: [] },
  }, // decideWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/approve': {
    high: { anyOfRoles: ['approver'], anyOfCapabilities: ['manage_policies'] },
    critical: { anyOfRoles: ['owner'], anyOfCapabilities: [] },
  }, // approveWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/reject': {
    high: { anyOfRoles: ['approver'], anyOfCapabilities: ['manage_policies'] },
    critical: { anyOfRoles: ['owner'], anyOfCapabilities: [] },
  }, // rejectWorkspaceApprovalRequest
  'POST /api/v1/workspaces/{workspace_id}/approval-requests/{approval_id}/request-changes': {
    high: { anyOfRoles: ['approver'], anyOfCapabilities: ['manage_policies'] },
    critical: { anyOfRoles: ['owner'], anyOfCapabilities: [] },
  }, // requestChangesWorkspaceApprovalRequest
};

/**
 * The one rule every decision operation carries (the generator refuses
 * operations that disagree). The client's only approver rule.
 */
export const GENERATED_APPROVER_RULE: ApproverRule = {
  high: { anyOfRoles: ['approver'], anyOfCapabilities: ['manage_policies'] },
  critical: { anyOfRoles: ['owner'], anyOfCapabilities: [] },
};
